// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JointSigningForm_signatureSuccess__ALEd1 {
  color: #111111;
}
.JointSigningForm_signatureSuccess__ALEd1 .JointSigningForm_msg__-tFEq {
  text-align: center;
  font-size: 24px;
  font-weight: 300;
}
.JointSigningForm_signatureSuccess__ALEd1 .JointSigningForm_details__-DqQf {
  display: flex;
  justify-content: space-around;
  margin: 48px 0;
  font-size: 12px;
}
.JointSigningForm_signatureSuccess__ALEd1 .JointSigningForm_details__-DqQf .JointSigningForm_value__mtqh\\+ {
  color: rgba(17, 17, 17, 0.568627451);
}

.JointSigningForm_previewImg__3jZg8 {
  max-width: 100%;
  max-height: 300px;
}

.JointSigningForm_uploadBtn__cf9SR {
  width: auto;
}
.JointSigningForm_uploadBtn__cf9SR label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: auto;
  cursor: pointer;
  background-color: #ededed;
  padding: 12px;
  border-radius: 4px;
  transition-duration: 0.3s;
}
.JointSigningForm_uploadBtn__cf9SR label:hover {
  background-color: #666666;
  color: #fff;
}
.JointSigningForm_uploadBtn__cf9SR input {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/JointDetails/JointSigningForm.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAEJ;AAAE;EACE,aAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAEJ;AADI;EACE,oCAAA;AAGN;;AAEA;EACE,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AACJ;AAAI;EACE,yBAAA;EACA,WAAA;AAEN;AACE;EACE,aAAA;AACJ","sourcesContent":[".signatureSuccess {\r\n  color: #111111;\r\n  .msg {\r\n    text-align: center;\r\n    font-size: 24px;\r\n    font-weight: 300;\r\n  }\r\n  .details {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin: 48px 0;\r\n    font-size: 12px;\r\n    .value {\r\n      color: #11111191;\r\n    }\r\n  }\r\n}\r\n\r\n.previewImg {\r\n  max-width: 100%;\r\n  max-height: 300px;\r\n}\r\n\r\n.uploadBtn {\r\n  width: auto;\r\n  // Replicate Button behaviour\r\n  label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: auto;\r\n    cursor: pointer;\r\n    background-color: #ededed;\r\n    padding: 12px;\r\n    border-radius: 4px;\r\n    transition-duration: 0.3s;\r\n    &:hover {\r\n      background-color: #666666;\r\n      color: #fff;\r\n    }\r\n  }\r\n  input {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signatureSuccess": `JointSigningForm_signatureSuccess__ALEd1`,
	"msg": `JointSigningForm_msg__-tFEq`,
	"details": `JointSigningForm_details__-DqQf`,
	"value": `JointSigningForm_value__mtqh+`,
	"previewImg": `JointSigningForm_previewImg__3jZg8`,
	"uploadBtn": `JointSigningForm_uploadBtn__cf9SR`
};
export default ___CSS_LOADER_EXPORT___;
